import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const requestGetWorkersList = () =>
    axios.get(`${apiUrl}Employees`);

export const requestGetWorkerFullById = (id) =>
    axios.get(`${apiUrl}Employees/${id}/full`);

export const requestInsertWorker = (data) =>
    axios.post(`${apiUrl}Employees/create`, data);

export const requestUpdateWorker = (id, data) =>
    axios.put(`${apiUrl}Employees/${id}`, data);

export const requestGetPayRateOverrides = (employeeId) =>
    axios.get(`${apiUrl}Employees/${employeeId}/payrateoverrides`);

export const requestGetPayRateOverrideSingle = (employeeId, overrideId) =>
    axios.get(`${apiUrl}Employees/${employeeId}/payrateoverrides/${overrideId}`);

export const requestCreatePayRateOverrideSingle = (employeeId, data) =>
    axios.post(`${apiUrl}Employees/${employeeId}/payrateoverrides`, data);

export const requestUpdatePayRateOverrideSingle = (employeeId, overrideId, data) =>
    axios.put(`${apiUrl}Employees/${employeeId}/payrateoverrides/${overrideId}`, data);

export const requestDeletePayRateOverrideSingle = (employeeId, overrideId) =>
    axios.delete(`${apiUrl}Employees/${employeeId}/payrateoverrides/${overrideId}`);

export const requestGetComments = (employeeId) =>
    axios.get(`${apiUrl}Employees/${employeeId}/comments`);

export const requestGetComment = (employeeId, commentId) =>
    axios.get(`${apiUrl}Employees/${employeeId}/comments/${commentId}`);

export const requestDeleteComment = (employeeId, commentId) =>
    axios.delete(`${apiUrl}Employees/${employeeId}/comments/${commentId}`);

export const requestCreateComment = (employeeId, data) =>
    axios.post(`${apiUrl}Employees/${employeeId}/comments`, data);

export const requestUpdateComment = (employeeId, commentId, data) =>
    axios.put(`${apiUrl}Employees/${employeeId}/comments/${commentId}`, data);

export const requestResetPassword = (employeeId, password) =>
    axios.put(`${apiUrl}Employees/${employeeId}/password`, {
        password
    });
